import React from "react";

const SortableTableHeader = ({
  label,
  columnKey,
  sortIcon,
  style = {},
  onSort,
  className = "",
}) => {
  return (
    <th
      className={`text-center text-sm text-gray-600 cursor-pointer hover:text-[#2e67be] transition-colors ${className}`}
      onClick={() => onSort(columnKey)}
      style={style}
    >
      <div className="flex items-center justify-center gap-2">
        <span>{label}</span>
        {sortIcon && <span className="text-gray-400">{sortIcon}</span>}
      </div>
    </th>
  );
};

export default SortableTableHeader;
